// Preserve the source brief alongside the extracted per-image direction. The
// source can describe a whole set; only the selected tile should be generated.
function contextForTile(context, label) {
  const headings = [...context.matchAll(/^(?:Tile|Image|Asset)\s+\d+\s*[|.:—–-]?\s*(.+)$/gmi)];
  const normalize = value => String(value || '').toLowerCase().replace(/^[\s|:.-]+/, '').trim();
  const selected = headings.findIndex(heading => normalize(heading[1]) === normalize(label));

  if (selected < 0) return context;

  const lastHeading = headings[headings.length - 1];
  const tail = context.slice(lastHeading.index + lastHeading[0].length);
  const footer = /^(?:Across (?:the )?(?:full|whole) set\b|Legal mandatories:|Brand guidelines:|Assets included:)/mi.exec(tail);
  const footerStart = footer ? lastHeading.index + lastHeading[0].length + footer.index : context.length;
  const end = selected + 1 < headings.length ? headings[selected + 1].index : footerStart;

  return [
    context.slice(0, headings[0].index).trim(),
    context.slice(headings[selected].index, end).trim(),
    context.slice(footerStart).trim(),
  ].filter(Boolean).join('\n\n');
}

export function briefImageInstructions(context, direction, label, {
  separate = false,
  noProduct = false,
} = {}) {
  if (!context) return direction || null;

  const selectedContext = contextForTile(context, label);
  const callouts = /(?:^|\n)Callouts(?:\s*\/[^:\n]+)?:\s*\n([\s\S]*?)(?=\nVisual direction:|$)/i.exec(selectedContext);
  const parts = [
    `SOURCE BRIEF (shared requirements and the selected tile's original text):\n${selectedContext}`,
    `GENERATE ONLY THIS IMAGE: ${label || 'the selected image'}. Use the source brief's shared aesthetic, market, specifications and mandatory constraints. These requirements take priority over reference imagery and default styling. Other tiles are context only; do not combine them into a collage or copy their headlines and callouts into this image. Use this tile's specified headline and callouts, rather than substituting claims from the packaging or reference images. Respect the rendering mode for editable overlay text.`,
  ];

  if (direction) {
    parts.push(`DIRECTION FOR THIS IMAGE (including any requested changes):\n${direction}`);
  }

  if (separate || noProduct) {
    parts.push('This generation must contain NO product or packaging, even if the source brief describes a product. Any required product is placed separately; leave its area empty.');
  } else {
    parts.push('Use only the supplied product packaging for the specified market. Keep its identity, wording and artwork unchanged. Do not add a second copy or keep a reference image\'s product behind it unless this specific image explicitly requests multiple products.');
  }

  if (selectedContext !== context && callouts) {
    parts.push(`REQUIRED CALLOUTS FOR THIS IMAGE — render every item clearly as designed text outside the product, even for a lifestyle photograph:\n${callouts[1].trim()}\nDo not omit these callouts or replace them with the headline. Keep them separate from the packaging artwork.`);
  }

  return parts.join('\n\n');
}

export function inspirationInstructions(urls) {
  return (urls || []).length
    ? ' The additional inspiration images are STYLE GUIDANCE ONLY: use their mood, lighting, materials and palette. Do not copy their products, packaging, logos, text or claims. Follow the brief and the selected image direction for composition and content.'
    : '';
}
